export default "__VITE_ASSET__C_p486kk__"